import React from 'react';
import { FiGithub, FiLinkedin } from 'react-icons/fi';
import { SiFiverr, SiUpwork } from 'react-icons/si';
import './fixed.css';
import { profile } from '../../data/profile';

const links = [
  { href: profile.github, label: 'GitHub', icon: <FiGithub /> },
  { href: profile.linkedin, label: 'LinkedIn', icon: <FiLinkedin /> },
  { href: profile.upwork, label: 'Upwork', icon: <SiUpwork /> },
  { href: profile.fiverr, label: 'Fiverr', icon: <SiFiverr /> },
];

const FixedSocials = () => (
  <div className="fixed__socials" aria-label="Social profiles">
    {links.map((link) => (
      <a key={link.label} href={link.href} target="_blank" rel="noreferrer" aria-label={link.label}>
        {link.icon}
      </a>
    ))}
  </div>
);

export default FixedSocials;
